var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkinektLogoHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 22.651,
    viewBox: "0 0 150 22.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4283",
    transform: "translate(54.724 .001)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h4.506v4.266H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12342",
    d: "M-1413.03 776.437v4.263h4.506v14.119h-4.506v4.266h13.277v-4.266h-4.506V780.7l-4.266-4.266z",
    transform: "translate(1458.982 -776.436)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12343",
    d: "M-1383.815 776.437v4.263h10.38v18.385h4.266V780.7l-4.266-4.266z",
    transform: "translate(1451.91 -776.436)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4284",
    transform: "translate(63.83 4.267)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h4.266v18.385H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12344",
    d: "M-1358.627 780.7v14.1l4.266 4.266h13.624V794.8h-13.624v-4.91h9.361v-4.266h-9.358V780.7h13.624v-4.266h-13.624z",
    transform: "translate(1445.813 -776.436)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4285",
    transform: "translate(142.701 .001)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h7.299v4.266H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12345",
    d: "M-1300.4 776.437v4.263h7.114v18.385h4.266V780.7l-4.266-4.266z",
    transform: "translate(1431.718 -776.436)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12346",
    d: "M-1325.926 776.437h-4.266v22.651h4.266V789.9h10.173v-4.27h-10.173z",
    transform: "translate(1438.93 -776.436)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12347",
    d: "M-1311.14 781.363v4.267l4.267-4.267v-4.927h-4.267z",
    transform: "translate(1434.319 -776.436)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12348",
    d: "M-1311.14 803.386h4.267v-4.927l-4.267-4.267z",
    transform: "translate(1434.319 -780.734)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12349",
    d: "M-1439.148 776.437h-4.266v22.651h4.266V789.9h10.172v-4.27h-10.172z",
    transform: "translate(1466.336 -776.436)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12350",
    d: "M-1424.361 781.363v4.267l4.267-4.267v-4.927h-4.267z",
    transform: "translate(1461.724 -776.436)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12351",
    d: "M-1424.361 803.386h4.267v-4.927l-4.267-4.267z",
    transform: "translate(1461.724 -780.734)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4286",
    transform: "translate(2.133 18.378)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h13.352v4.266H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12352",
    d: "M-1456.809 788.563h-11.222l4.267 4.267h6.955v4.918h4.266v-4.922l-4.263-4.263z",
    transform: "translate(1472.296 -779.371)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12353",
    d: "M-1469.391 780.7h13.352v-4.266h-13.352l-4.266 4.266v.658l4.26 4.268V780.7z",
    transform: "translate(1473.657 -776.436)",
    style: {
      fill: "#cdea50"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinektLogoHeader);
export default __webpack_public_path__ + "static/media/skinekt-logo-header.8d294392090ec86eb56efcf89fb5c4e9.svg";
export { ForwardRef as ReactComponent };